<div class="choose-payment__wrapper">
    <h3 class="payment-methodTitle">{{'customCashier.choosePaymentMethod' | translate}}</h3>
    <div class="payment-methodDropdown">
        <button  role="button"  class="payment-methodDropdown__button" [ngClass]="isShowList ? 'active' : ''" (click)="toggleSelector()">
            <div class="dropdown-btnContent">
                <div class="mob-word--break">
                    <h4 class="dropdown-cardTitle">{{ selectedValue?.jsonKey | translate}}</h4>
                    <h5 class="dropdown-depositTitle">{{'customCashier.minDepositText' | translate}}{{selectedValue?.minAmount | currencyPipe}}</h5>
                </div>
                <div class="payment-cardLogo">
                    <img [src]="selectedValue?.logoUrl" alt="{{getTranslation(selectedValue?.jsonKey)}}" [ngClass]="selectorData && selectorData.length > 1 ? '' : 'single-method'">
                    <i class="icon icon-dropdown-arrow payment-dropdownIcon" *ngIf="selectorData && selectorData.length >1"></i>
                </div>
            </div>
        </button>
        <div class="payment-methodDropdown__list">
            <ul *ngIf="selectorData && selectorData.length">
                <li class="payment-methodDropdown__list-item" *ngFor="let value of selectorData" (click)="onChangeSelector(value)" [ngClass]="value.name== selectedValue.name ? 'selected' : ''">
                    <div class="dropdownListContent">
                        <div class="dropdownList-container">
                            <div class="dropdownList-item">
                                <h4 class="dropdown-cardTitle">{{value.jsonKey | translate}}</h4>
                                <h5 class="dropdown-depositTitle">{{'customCashier.minDepositText' | translate}} {{value.minAmount | currencyPipe}}</h5>
                            </div>
                            <!-- <div class="dropdownList-cashier--recommended">
                                <span>Recommended</span>
                            </div> -->
                        </div>
                        <div class="payment-cardLogo">
                            <img [src]="value.logoUrl" alt="{{getTranslation(value.jsonKey)}}">
                        </div>
                    </div>
                </li>
            </ul>
            <div class="payment-method--showmoreBtn" (click)="showMoreList()" *ngIf="!isShowMoreClicked">
                <a>{{'customCashier.showMoreText' | translate}}</a>
            </div>
        </div>
    </div>
</div>